// export const MUSEME_API_ORIGIN = 'https://api.museme.com'
export const MUSEME_API_ORIGIN = 'https://dev-api.museme.com'
// export const MUSEME_LIVE_ORIGIN = 'https://live.museme.com'
export const MUSEME_LIVE_ORIGIN = 'https://dev-live.museme.com'
// export const MUSEME_POLL_ORIGIN = 'https://live.museme.com:7043'
export const MUSEME_POLL_ORIGIN = 'https://dev-live.museme.com:7043'
